import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
// import { cloneDeep } from 'lodash'

/** Devuelve un objeto con las claves especificadas
* @param {Array} props Claves que se conservarán en la copia de obj
* @param {Object} obj Objeto a copiar
* @returns {Object} Copia de obj con las claves especificadas en props
*/
function preserve (props, obj) {
  const aux = {}
  props.forEach(prop => setNestedValue(prop, aux, getNestedValue(prop, obj)))
  return aux
  //   return discard(Object.keys(obj).filter(x => !props.map(p => String(p)).includes(x)), obj)
}

/** Devuelve un objeto sin las claves especificadas
 * @param {Array} props Claves que se eliminarán en la copia de obj
 * @param {Object} obj Objeto a copiar
 * @returns {Object} Copia de obj sin las claves especificadas en props
*/
function discard (props, obj) {
  const aux = { ...obj } // cloneDeep(obj)
  props.forEach(prop => setNestedValue(prop, aux, undefined))
  return aux
//   return props.reduce((acc, prop) => (({ [prop]: _, ...rest }) => rest)(acc), obj)
}

export { preserve, discard }
